// ─── Recurring Transactions ───────────────────────────────────────────────────
// history = last 6 months of amounts (oldest → newest)
export const RECURRING_TRANSACTIONS = [
  { id: 1,  merchant: "Rent / Mortgage",      category: "Housing",       icon: "🏠", amount: 1850.00, frequency: "Monthly",  nextDate: "Apr 1",  active: true,  trend: "stable",     history: [1850, 1850, 1850, 1850, 1850, 1850] },
  { id: 2,  merchant: "Car Insurance",        category: "Insurance",     icon: "🚗", amount:  142.00, frequency: "Monthly",  nextDate: "Apr 5",  active: true,  trend: "increasing", history: [132,  132,  132,  138,  138,  142 ] },
  { id: 3,  merchant: "Electric Bill",        category: "Utilities",     icon: "⚡", amount:  124.00, frequency: "Monthly",  nextDate: "Mar 25", active: true,  trend: "seasonal",   history: [170,  135,  118,  124,  148,  124 ] },
  { id: 4,  merchant: "Internet — Xfinity",  category: "Utilities",     icon: "📡", amount:   79.99, frequency: "Monthly",  nextDate: "Mar 28", active: true,  trend: "stable",     history: [74.99,74.99,74.99,74.99,79.99,79.99] },
  { id: 5,  merchant: "Gym Membership",       category: "Health",        icon: "💪", amount:   49.00, frequency: "Monthly",  nextDate: "Mar 20", active: true,  trend: "stable",     history: [45,   45,   45,   49,   49,   49  ] },
  { id: 6,  merchant: "Netflix",              category: "Subscriptions", icon: "🎬", amount:   15.99, frequency: "Monthly",  nextDate: "Mar 13", active: true,  trend: "stable",     history: [13.99,13.99,13.99,15.99,15.99,15.99] },
  { id: 7,  merchant: "Spotify Premium",      category: "Subscriptions", icon: "🎵", amount:    9.99, frequency: "Monthly",  nextDate: "Mar 18", active: true,  trend: "stable",     history: [9.99, 9.99, 9.99, 9.99, 9.99, 9.99] },
  { id: 8,  merchant: "Hulu",                 category: "Subscriptions", icon: "📺", amount:   17.99, frequency: "Monthly",  nextDate: "Mar 22", active: true,  trend: "increasing", history: [15.99,15.99,15.99,15.99,17.99,17.99] },
  { id: 9,  merchant: "Amazon Prime",         category: "Shopping",      icon: "📦", amount:   14.99, frequency: "Monthly",  nextDate: "Apr 1",  active: true,  trend: "increasing", history: [12.99,12.99,12.99,14.99,14.99,14.99] },
  { id: 10, merchant: "Adobe Creative Cloud", category: "Subscriptions", icon: "🎨", amount:   54.99, frequency: "Monthly",  nextDate: "Mar 16", active: false, trend: "stable",     history: [54.99,54.99,54.99,54.99,54.99,54.99] },
  { id: 11, merchant: "Renter's Insurance",   category: "Insurance",     icon: "🏡", amount:   24.00, frequency: "Monthly",  nextDate: "Apr 1",  active: true,  trend: "stable",     history: [22,   22,   24,   24,   24,   24  ] },
  { id: 12, merchant: "New York Times",        category: "Subscriptions", icon: "📰", amount:   17.00, frequency: "Monthly",  nextDate: "Mar 19", active: true,  trend: "increasing", history: [4,    4,    17,   17,   17,   17  ] },
];

// ─── Monthly Spending Trend (12 months: Mar 2025 – Feb 2026) ─────────────────
export const MONTHLY_SPENDING_TREND = [
  { month: "Mar '25", total: 3180, groceries: 320, dining: 255, transport: 310, subscriptions: 218, shopping: 420, utilities: 198, health: 144, other: 315 },
  { month: "Apr",     total: 3260, groceries: 345, dining: 310, transport: 295, subscriptions: 218, shopping: 380, utilities: 192, health: 144, other: 376 },
  { month: "May",     total: 3420, groceries: 310, dining: 340, transport: 320, subscriptions: 218, shopping: 510, utilities: 190, health: 188, other: 344 },
  { month: "Jun",     total: 3580, groceries: 290, dining: 420, transport: 330, subscriptions: 218, shopping: 620, utilities: 185, health: 144, other: 373 },
  { month: "Jul",     total: 3820, groceries: 315, dining: 450, transport: 290, subscriptions: 218, shopping: 780, utilities: 188, health: 232, other: 347 },
  { month: "Aug",     total: 3650, groceries: 380, dining: 395, transport: 305, subscriptions: 218, shopping: 640, utilities: 190, health: 144, other: 378 },
  { month: "Sep",     total: 3200, groceries: 420, dining: 310, transport: 315, subscriptions: 218, shopping: 380, utilities: 198, health: 144, other: 215 },
  { month: "Oct",     total: 3800, groceries: 395, dining: 360, transport: 320, subscriptions: 218, shopping: 620, utilities: 210, health: 188, other: 489 },
  { month: "Nov",     total: 4200, groceries: 410, dining: 380, transport: 295, subscriptions: 218, shopping: 1050,utilities: 235, health: 144, other: 468 },
  { month: "Dec",     total: 5100, groceries: 480, dining: 560, transport: 280, subscriptions: 218, shopping: 1820,utilities: 250, health: 144, other: 348 },
  { month: "Jan '26", total: 3400, groceries: 440, dining: 290, transport: 310, subscriptions: 218, shopping: 450, utilities: 242, health: 232, other: 218 },
  { month: "Feb",     total: 3100, groceries: 420, dining: 270, transport: 295, subscriptions: 218, shopping: 380, utilities: 238, health: 144, other: 135 },
];

// ─── Projected Spending (next 3 months) ───────────────────────────────────────
export const PROJECTED_MONTHS = [
  {
    month: "Mar '26", low: 2720, base: 3080, high: 3540,
    breakdown: { groceries: 430, dining: 285, transport: 305, subscriptions: 218, shopping: 420, utilities: 245, health: 145, other: 32 },
  },
  {
    month: "Apr '26", low: 2900, base: 3290, high: 3790,
    breakdown: { groceries: 375, dining: 330, transport: 290, subscriptions: 218, shopping: 470, utilities: 235, health: 145, other: 227 },
  },
  {
    month: "May '26", low: 3010, base: 3450, high: 3970,
    breakdown: { groceries: 355, dining: 365, transport: 315, subscriptions: 218, shopping: 545, utilities: 198, health: 190, other: 264 },
  },
];

// ─── Mock Data ────────────────────────────────────────────────────────────────
export const ACCOUNTS = [
  { id: 1, name: "Chase Checking",  type: "checking",   bank: "Chase",            balance:   8420.55, change:  +142.30, icon: "🏦" },
  { id: 2, name: "Fidelity Savings",type: "savings",    bank: "Fidelity",         balance:  34210.00, change:   +85.00, icon: "💰" },
  { id: 3, name: "Amex Gold",       type: "credit",     bank: "American Express", balance:  -2840.12, change:  -320.00, icon: "💳" },
  { id: 4, name: "Robinhood",       type: "investment", bank: "Robinhood",        balance:  52340.88, change: +1240.50, icon: "📈" },
  { id: 5, name: "Vanguard IRA",    type: "investment", bank: "Vanguard",         balance: 128500.00, change: +3200.00, icon: "🏛️" },
  { id: 6, name: "Student Loan",    type: "debt",       bank: "Navient",          balance: -18400.00, change:  +150.00, icon: "🎓" },
];

export const TRANSACTIONS = [
  { id: 1, merchant: "Whole Foods Market",  category: "Groceries",    amount:   -87.43, date: "Today",     account: "Amex Gold",       icon: "🛒" },
  { id: 2, merchant: "Netflix",             category: "Subscriptions", amount:   -15.99, date: "Today",     account: "Chase Checking",  icon: "🎬" },
  { id: 3, merchant: "Direct Deposit",      category: "Income",        amount: +3400.00, date: "Yesterday", account: "Chase Checking",  icon: "💵" },
  { id: 4, merchant: "Shell Gas Station",   category: "Transport",     amount:   -54.20, date: "Yesterday", account: "Amex Gold",       icon: "⛽" },
  { id: 5, merchant: "Spotify Premium",     category: "Subscriptions", amount:    -9.99, date: "Mar 5",     account: "Chase Checking",  icon: "🎵" },
  { id: 6, merchant: "Amazon",              category: "Shopping",      amount:  -132.50, date: "Mar 5",     account: "Amex Gold",       icon: "📦" },
  { id: 7, merchant: "Dividend — AAPL",     category: "Investment",    amount:   +42.10, date: "Mar 4",     account: "Robinhood",       icon: "📊" },
  { id: 8, merchant: "Restaurant Milo",     category: "Dining",        amount:   -68.00, date: "Mar 4",     account: "Amex Gold",       icon: "🍽️" },
];

export const SPENDING_DATA = [
  { month: "Sep", spending: 3200, income: 6800 },
  { month: "Oct", spending: 3800, income: 6800 },
  { month: "Nov", spending: 4200, income: 7200 },
  { month: "Dec", spending: 5100, income: 7200 },
  { month: "Jan", spending: 3400, income: 6800 },
  { month: "Feb", spending: 3100, income: 6800 },
  { month: "Mar", spending: 2800, income: 6800 },
];

export const NET_WORTH_DATA = [
  { month: "Sep", value: 185000 },
  { month: "Oct", value: 188400 },
  { month: "Nov", value: 186200 },
  { month: "Dec", value: 190800 },
  { month: "Jan", value: 194200 },
  { month: "Feb", value: 199100 },
  { month: "Mar", value: 202231 },
];

export const BUDGET_CATEGORIES = [
  { name: "Housing",       allocated: 1800, spent: 1800, color: "#E8D5B7" },
  { name: "Groceries",     allocated:  600, spent:  487, color: "#52D68A" },
  { name: "Transport",     allocated:  400, spent:  312, color: "#B8D4E8" },
  { name: "Dining",        allocated:  350, spent:  380, color: "#F4B8B8" },
  { name: "Subscriptions", allocated:  150, spent:  126, color: "#D4B8E8" },
  { name: "Shopping",      allocated:  500, spent:  388, color: "#F4D8B8" },
];

export const PIE_DATA = [
  { name: "Investments", value: 180841, color: "#D4AF37" },
  { name: "Savings",     value:  34210, color: "#8BAF9A" },
  { name: "Checking",    value:   8421, color: "#7A9BAF" },
];

export const INVESTMENTS = [
  { ticker: "VTSAX", name: "Vanguard Total Stock Market", shares: 523.4, price: 118.20, avgPrice:  89.28, value: 61860.0, gain: 32.4, gainAmt: 14940.0 },
  { ticker: "VTI",   name: "Vanguard Total Market ETF",   shares: 210.8, price: 215.40, avgPrice: 182.23, value: 45406.3, gain: 18.2, gainAmt:  6990.0 },
  { ticker: "AAPL",  name: "Apple Inc.",                  shares:  48.0, price: 193.50, avgPrice: 135.50, value:  9288.0, gain: 42.8, gainAmt:  2781.0 },
  { ticker: "MSFT",  name: "Microsoft Corporation",       shares:  32.5, price: 415.80, avgPrice: 323.33, value: 13513.5, gain: 28.6, gainAmt:  3011.0 },
  { ticker: "BND",   name: "Vanguard Bond Market ETF",    shares: 415.2, price: 125.50, avgPrice: 116.10, value: 52108.0, gain:  8.1, gainAmt:  3896.0 },
];

// ─── Portfolio chart data per time range ──────────────────────────────────────
export const PORTFOLIO_CHART_DATA = {
  "1D": [
    { label: "9:00",  value: 200991 },
    { label: "9:30",  value: 201180 },
    { label: "10:00", value: 200820 },
    { label: "10:30", value: 201350 },
    { label: "11:00", value: 201540 },
    { label: "12:00", value: 201120 },
    { label: "13:00", value: 201680 },
    { label: "14:00", value: 201920 },
    { label: "15:00", value: 201740 },
    { label: "16:00", value: 202231 },
  ],
  "1W": [
    { label: "Mar 6",  value: 199820 },
    { label: "Mar 7",  value: 200140 },
    { label: "Mar 8",  value: 200580 },
    { label: "Mar 9",  value: 200220 },
    { label: "Mar 10", value: 201050 },
    { label: "Mar 11", value: 201540 },
    { label: "Mar 12", value: 202231 },
  ],
  "1M": [
    { label: "Feb 10", value: 197200 },
    { label: "Feb 14", value: 197840 },
    { label: "Feb 18", value: 198520 },
    { label: "Feb 21", value: 198100 },
    { label: "Feb 25", value: 199100 },
    { label: "Mar 1",  value: 199820 },
    { label: "Mar 5",  value: 200540 },
    { label: "Mar 8",  value: 201200 },
    { label: "Mar 12", value: 202231 },
  ],
  "6M": [
    { label: "Sep", value: 185000 },
    { label: "Oct", value: 188400 },
    { label: "Nov", value: 186200 },
    { label: "Dec", value: 190800 },
    { label: "Jan", value: 194200 },
    { label: "Feb", value: 199100 },
    { label: "Mar", value: 202231 },
  ],
  "YTD": [
    { label: "Jan 1",  value: 192000 },
    { label: "Jan 15", value: 193500 },
    { label: "Feb 1",  value: 196800 },
    { label: "Feb 15", value: 198400 },
    { label: "Mar 1",  value: 199820 },
    { label: "Mar 12", value: 202231 },
  ],
  "1Y": [
    { label: "Mar '25", value: 178400 },
    { label: "Apr",     value: 180200 },
    { label: "May",     value: 179600 },
    { label: "Jun",     value: 182000 },
    { label: "Jul",     value: 184500 },
    { label: "Aug",     value: 183200 },
    { label: "Sep",     value: 185000 },
    { label: "Oct",     value: 188400 },
    { label: "Nov",     value: 186200 },
    { label: "Dec",     value: 190800 },
    { label: "Jan '26", value: 194200 },
    { label: "Feb",     value: 199100 },
    { label: "Mar",     value: 202231 },
  ],
  "5Y": [
    { label: "2021 Q1", value: 142000 },
    { label: "2021 Q3", value: 151000 },
    { label: "2022 Q1", value: 136500 },
    { label: "2022 Q3", value: 128500 },
    { label: "2023 Q1", value: 148200 },
    { label: "2023 Q3", value: 156800 },
    { label: "2024 Q1", value: 165400 },
    { label: "2024 Q3", value: 178200 },
    { label: "2025 Q1", value: 172000 },
    { label: "2025 Q3", value: 185000 },
    { label: "2026 Q1", value: 202231 },
  ],
  "MAX": [
    { label: "2018", value:  45000 },
    { label: "2019", value:  62000 },
    { label: "2020", value:  74000 },
    { label: "2021", value: 142000 },
    { label: "2022", value: 128500 },
    { label: "2023", value: 156800 },
    { label: "2024", value: 178200 },
    { label: "2026", value: 202231 },
  ],
};

// ─── Comparison chart data (raw values, normalized to % in component) ─────────
// Each array aligns point-for-point with PORTFOLIO_CHART_DATA for the same range
export const COMPARISON_CHART_DATA = {
  SPY: {
    "1D":  [5780, 5795, 5785, 5802, 5812, 5808, 5818, 5825, 5820, 5830],
    "1W":  [5720, 5740, 5755, 5748, 5762, 5775, 5830],
    "1M":  [5680, 5710, 5735, 5720, 5765, 5790, 5810, 5825, 5830],
    "6M":  [5600, 5640, 5580, 5680, 5720, 5780, 5830],
    "YTD": [5935, 5920, 5880, 5850, 5840, 5830],
    "1Y":  [5080, 5120, 5090, 5140, 5200, 5180, 5250, 5340, 5300, 5450, 5520, 5720, 5830],
    "5Y":  [3750, 4200, 3700, 3590, 4100, 4400, 5200, 5600, 4800, 5600, 5830],
    "MAX": [2490, 3230, 3756, 4793, 3840, 4770, 5200, 5830],
  },
  QQQ: {
    "1D":  [490, 493, 491, 495, 497, 495, 498, 500, 499, 502],
    "1W":  [485, 487, 490, 488, 492, 495, 502],
    "1M":  [478, 482, 486, 483, 490, 494, 498, 500, 502],
    "6M":  [460, 468, 455, 472, 482, 494, 502],
    "YTD": [515, 510, 500, 497, 498, 502],
    "1Y":  [420, 428, 422, 432, 445, 440, 455, 468, 460, 478, 488, 498, 502],
    "5Y":  [325, 380, 280, 270, 365, 410, 480, 520, 440, 490, 502],
    "MAX": [175, 232, 338, 400, 268, 378, 462, 502],
  },
  AAPL: {
    "1D":  [192.2, 193.0, 192.5, 193.8, 194.2, 193.9, 194.5, 194.8, 194.4, 193.5],
    "1W":  [190.0, 191.2, 192.0, 191.5, 192.5, 193.0, 193.5],
    "1M":  [187.0, 188.5, 190.0, 189.2, 191.0, 192.0, 192.8, 193.2, 193.5],
    "6M":  [175.0, 178.0, 172.0, 180.0, 185.0, 190.0, 193.5],
    "YTD": [200.0, 197.0, 191.0, 188.0, 190.0, 193.5],
    "1Y":  [155.0, 158.0, 155.0, 160.0, 165.0, 162.0, 168.0, 175.0, 172.0, 180.0, 185.0, 190.0, 193.5],
    "5Y":  [133.0, 152.0, 130.0, 142.0, 172.0, 185.0, 190.0, 175.0, 165.0, 182.0, 193.5],
    "MAX": [44.0, 72.0, 130.0, 178.0, 128.0, 190.0, 183.0, 193.5],
  },
  MSFT: {
    "1D":  [414.0, 415.5, 414.8, 416.2, 417.0, 416.5, 417.2, 417.8, 417.0, 415.8],
    "1W":  [410.0, 411.5, 413.0, 412.0, 413.8, 414.5, 415.8],
    "1M":  [405.0, 407.0, 409.5, 408.0, 411.0, 413.0, 414.5, 415.2, 415.8],
    "6M":  [380.0, 385.0, 378.0, 390.0, 400.0, 410.0, 415.8],
    "YTD": [425.0, 420.0, 412.0, 408.0, 411.0, 415.8],
    "1Y":  [340.0, 345.0, 342.0, 355.0, 365.0, 360.0, 370.0, 385.0, 380.0, 395.0, 405.0, 412.0, 415.8],
    "5Y":  [232.0, 280.0, 242.0, 235.0, 290.0, 320.0, 380.0, 420.0, 370.0, 400.0, 415.8],
    "MAX": [98.0, 157.0, 218.0, 336.0, 240.0, 375.0, 418.0, 415.8],
  },
  BND: {
    "1D":  [124.8, 124.9, 124.85, 124.95, 125.0, 124.92, 125.05, 125.1, 125.05, 125.5],
    "1W":  [124.5, 124.6, 124.7, 124.65, 124.8, 124.9, 125.5],
    "1M":  [124.0, 124.15, 124.3, 124.2, 124.5, 124.7, 124.9, 125.2, 125.5],
    "6M":  [122.0, 122.5, 121.8, 122.8, 123.5, 124.5, 125.5],
    "YTD": [126.0, 125.8, 125.5, 125.3, 125.4, 125.5],
    "1Y":  [118.0, 118.5, 117.8, 119.0, 120.0, 119.5, 120.5, 122.0, 121.5, 123.0, 124.0, 125.0, 125.5],
    "5Y":  [118.0, 120.5, 107.0, 95.0, 104.0, 110.0, 118.0, 122.0, 116.0, 121.0, 125.5],
    "MAX": [92.0, 98.0, 110.0, 122.0, 95.0, 105.0, 118.0, 125.5],
  },
};

export const COMPARE_META = [
  { id: "SPY",  label: "S&P 500",    color: "#F4B8B8" },
  { id: "QQQ",  label: "Nasdaq 100", color: "#B8D4E8" },
  { id: "AAPL", label: "AAPL",       color: "#D4B8E8" },
  { id: "MSFT", label: "MSFT",       color: "#E8C87A" },
  { id: "BND",  label: "BND",        color: "#E8D5B7" },
];

// ─── Formatters ───────────────────────────────────────────────────────────────
export const fmt = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(n);

export const fmtShort = (n) => (n >= 1000 ? `$${(n / 1000).toFixed(1)}k` : fmt(n));
